import {
  GRID_CHECKBOX_SELECTION_FIELD,
  GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
  GridInitialState,
} from '@mui/x-data-grid-premium'

// A layout saved before the table was grouped won't list MUI's grouping column in `orderedFields`,
// and MUI drops any unlisted column at the end — pushing the group headers to the far right. Move
// the grouping column back to the front.
export const pinGroupingColumnFirst = (state: GridInitialState): GridInitialState => {
  const orderedFields = state.columns?.orderedFields
  // Saved state can be stale or hand-edited, so `orderedFields` might not be an array — guard before
  // `.filter` below so a bad value can't crash the grid on render (same guard DataGridBase uses).
  if (!Array.isArray(orderedFields) || orderedFields.length === 0) return state

  const rest = orderedFields.filter((field) => field !== GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD)
  const pinned =
    rest[0] === GRID_CHECKBOX_SELECTION_FIELD
      ? [rest[0], GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD, ...rest.slice(1)]
      : [GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD, ...rest]

  return { ...state, columns: { ...state.columns, orderedFields: pinned } }
}
